const OPTION_BLOCAGE = {
  etatSouhaite: 'Etat souhaité',
  etatProvisoire: 'Etat provisoire',
  etatObtenu: 'Etat obtenu',
  option: 'Option',
  aucun: 'Aucun',
  attenteReponse: 'En attente de validation',
  sansSuite: 'Sans suite',
  annulation: 'Annulation',
  indisponible: 'Indisponible',
  bloque: 'Bloqué',
  rang: 'Rang',
  relanceOption: 'Relance d’option',
  enAttente: 'Attente relance option',
  buttonAfficher: 'Afficher état obtenu',
  messageErreurEtat: 'Attention, il y a une différence entre l’état souhaité et l’état obtenu.',
  messageErreurQuantite: 'Attention, le nombre de faces souhaitées n\'est pas disponible.',
  messageErreurQuantiteNull: 'Attention, le nombre de faces souhaitées est à 0.',
  messageErreurFacesIndisponiblesEnBlocage: 'Attention, certaines faces ne sont plus disponibles en blocage. Veuillez consulter la pop-up de sélection.',
  detail: {
    souhaite: 'Souhaité: ',
    obtenu: 'Obtenu: ',
    rang: 'Rang: ',
  },
  popUp: {
    title: 'Attention, il existe une différence entre l’état affiché d’une option et l’enregistrement.',
    retour: 'Retour',
    continuer: 'Continuer',
  },
  informationOptionBlocage: {
    disponible: 'Disponible',
    duAu: 'du {jourDepart} {dateDebut} au {dateFin}, S{semaine}',
    format: 'Format: {libelleFormat}',
    departement: 'Dept: {departement}',
    face: 'face',
    faces: 'faces',
    fermer: 'Fermer',
    noDispo: 'Il n\'y a aucune face disponible pour cette semaine',
    noAffectation: "Aucune faces n'a été affectée",
    faceNotIn: "Cette face n'est pas dans le réseau",
    faceIn: 'Cette face est dans le réseau',
    voir: 'Afficher les faces affectées',
    cacher: 'Cacher les faces affectées',
    montantFace: 'Montant face :',
    montantLocation: 'Location :',
  },
  popUpModification: {
    title: 'Modification de l\'état souhaité',
    edit: 'Appliquer',
    cancel: 'Annuler',
  },
  libre: 'Libre',
  libreOption: 'Libre et option',
  libreOptionVendu: 'Libre / Option / Vendu',
};

export default OPTION_BLOCAGE;
